// @flow
import type {
  LoginOperator,
} from '../types'

// Operator Composer
import composeOperator from 'fc-operations'

// Exports
export default function getLoginOperator (): LoginOperator {
  return composeOperator({
    model: 'Login',
    branch: 'loginOperation',
  })
}
